import type { Game } from 'chessboard/model/game/types';
import { getWholeMoveNumber } from 'components/move-list/helpers/move-list-node-utils';

/**
 * Extend a move with ply and wholeMoveNumber.
 */
export function getExtendedNode({
  move,
  startingMoveNumber,
}: {
  move?: Game.Move.Node;
  startingMoveNumber: number;
}): Game.Move.Node | null {
  if (!move) {
    return null;
  }

  const wholeMoveNumber = getWholeMoveNumber(move, startingMoveNumber);

  return {
    ...move,
    ply: move.ids.move + 1,
    wholeMoveNumber,
  };
}
